export default {"src":"/_next/static/media/DE.fd4415d1.svg","height":355,"width":512,"blurWidth":0,"blurHeight":0};